import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import MarioVideo from '../assets/mario_bento_video.mp4';

const AboutSection = () => (
  <Box id="sobre" sx={{ bgcolor: 'background.paper', py: 8, width: '100%', px: { xs: 2, md: 5 }, overflowX: 'hidden' }}>
    <Grid 
      container 
      spacing={4} 
      alignItems="center"
    >
      
      {/* --- 1º ELEMENTO: VÍDEO --- */}
      {/* Desktop: Fica na metade ESQUERDA | Mobile: Fica no TOPO e centralizado */}
      <Grid 
        item 
        xs={12} 
        md={6} 
        sx={{ 
          display: 'flex',
          width: '100%', 
          // Mantém o vídeo centralizado na tela do celular e centralizado na sua própria metade no desktop
          justifyContent: 'center'
        }}
      >
        <Box 
          component="video"
          src={MarioVideo}
          controls
          autoPlay
          muted
          loop
          playsInline
          sx={{ 
            width: '100%', 
            maxWidth: 350, 
            height: 'auto',
            borderRadius: 4, 
            border: '2px solid #333', 
            boxShadow: '0 10px 30px rgba(255, 214, 0, 0.2)', // Sombra Amarela
            // Dá um espaço entre o vídeo e o texto abaixo dele apenas no celular
            mb: { xs: 4, md: 0 }
          }}
        />
      </Grid>

      {/* --- 2º ELEMENTO: TEXTO --- */}
      {/* Desktop: Fica na metade DIREITA | Mobile: Fica ABAIXO do vídeo */}
      <Grid item xs={12} md={6}>
        <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
          <Typography variant="h3" color="primary" gutterBottom>
            QUEM SOU EU
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mt: 2, textAlign: 'justify' }}>
            Sou professor de Educação Física e atuo como <strong>Personal Trainer</strong>, especializado em ajudar homens e mulheres a conquistarem emagrecimento de forma saudável, segura e definitiva.
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ textAlign: 'justify' }}>
            Formado há 2 anos e pós-graduado em <strong>Ciências do Treinamento de Força</strong>, busco constantemente atualização para aplicar métodos eficientes, baseados em evidências científicas.
          </Typography>
          
          <Typography variant="body1" sx={{ textAlign: 'justify' }}>
            Meu compromisso é conduzir cada aluno com profissionalismo, motivação e estratégia, para que o processo de emagrecimento seja sustentável e transformador.
          </Typography>
        </Box>
      </Grid>

    </Grid>
  </Box>
);

export default AboutSection;